// extracted by mini-css-extract-plugin
export var labelWrapper = "Label-module--labelWrapper--d0299";
export var required = "Label-module--required--62596";